import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppErrorsInterceptor, AuthTokenInterceptor, RefreshTokenInterceptor, TraceInterceptor } from './interceptors';

/**
 * App http interceptors
 */
export const APP_HTTP_INTERCEPTORS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RefreshTokenInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthTokenInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AppErrorsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TraceInterceptor,
    multi: true,
  },
];
